// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cashflow-label .colored-box[data-v-21970b13] {\n  width: 10px;\n  height: 10px;\n  border: none;\n  border-radius: 4px;\n  background-color: red;\n}", ""]);
// Exports
module.exports = exports;
